import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Url } from '../../Component/function/FunctionApi';
import { getCookie } from '../../Pages/Login/Login';
import debounce from 'lodash/debounce';

function FollowInvoiceContent() {
  const [searchValue, setSearchValue] = useState('');
  const [invoiceHistory, setInvoiceHistory] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const getToken = () => {
    const userCookie = getCookie("user");
    return userCookie ? JSON.parse(userCookie).token : null;
  };

  const fetchInvoiceHistory = async (invoiceId) => {
    try {
      setLoading(true);
      setError(null);
      const response = await axios.get(
        `${Url}Invoice/invoice-history/${invoiceId}`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      
      if (response.data.statusCode === 200) {
        setInvoiceHistory(response.data.data);
      } else {
        setError(response.data.message || 'حدث خطأ أثناء جلب بيانات الفاتورة');
      }
    } catch (err) {
      if (err.response && err.response.data && err.response.data.message) {
        setError(err.response.data.message);
      } else {
        setError('لا يوجد فاتوره بهذا الكود');
      }
      console.error('Error fetching invoice history:', err);
    } finally {
      setLoading(false);
    }
  };

  // Create a debounced version of fetchInvoiceHistory
  const debouncedFetch = useCallback(
    debounce((value) => {
      if (value.trim()) {
        fetchInvoiceHistory(value);
      }
    }, 500),
    []
  );

  // Handle input change with debounce
  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedFetch(value);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ar-SA', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl font-bold text-gray-800 mb-6 text-right">تتبع الفاتورة</h2>
        
        {/* Search Input */}
        <div className="mb-8">
          <input
            type="text"
            value={searchValue}
            onChange={handleInputChange}
            placeholder="أدخل رقم الفاتورة"
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 text-right"
          />
        </div>

        {/* Loading State */}
        {loading && (
          <div className="text-center py-4">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
          </div>
        )}

        {/* Error State */}
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        {/* Invoice History List */}
        {!loading && !error && invoiceHistory.length > 0 && (
          <div className="bg-white rounded-lg shadow-md overflow-hidden">
            <div className="divide-y divide-gray-200">
              {invoiceHistory.map((item) => (
                <div key={item.id} className="p-6 hover:bg-gray-50">
                  <div className="flex justify-between items-start">
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">{item.actionType}</h3>
                      <p className="text-gray-600 mb-2">{item.changesDescription}</p>
                      <div className="flex items-center text-sm text-gray-500">
                        <span className="ml-4">{item.userName}</span>
                        <span>{formatDate(item.actionDate)}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* No Results */}
        {!loading && !error && invoiceHistory.length === 0 && searchValue && (
          <div className="text-center py-8 text-gray-500">
            لا توجد نتائج للبحث
          </div>
        )}
      </div>
    </div>
  );
}

export default FollowInvoiceContent;
